import React, { useState, useEffect } from 'react';

// Libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useSelector } from 'react-redux';
import { useNodeId } from '@xyflow/react';

// Funções
import { useNodeUpdate } from '~/hooks/useNodeUpdate';

// Utilitários
import { NodeHeaderCustomDeleteAction } from '~/utils/NodeHeaderCustomDeleteAction';
import { NodeHeaderCustomAlertAction } from '~/utils/NodeHeaderCustomAlertAction';
import { CustomSelect } from '~/utils/CustomSelect';
import { CustomHandle } from '~/utils/CustomHandle';
import { InputRichVariavel } from '~/utils/InputRichVariavel';

// Node de leitura
// Este componente permite que o usuário leia uma mensagem e escolha uma variável para armazenar a resposta
// Ele também permite que o usuário escolha entre diferentes tipos de entrada (texto ou lógico)
export const LerNode = ({ data }) => {
    const id = useNodeId();
    const { onNodesChange } = useNodeUpdate();
    const variaveis = useSelector((state) => state.variaveis);
    const [mensagem, setMensagem] = useState(data.mensagem || "");
    const [tipo, setTipo] = useState(data.tipo || "texto");
    const [variavel, setVariavel] = useState(data.variavel || "");
    const [isExpanded, setIsExpanded] = useState(false);
    const [listaPendencias, setListaPendencias] = useState([]);

    // Sync state on undo/redo
    useEffect(() => { setMensagem(data.mensagem || ""); }, [data.mensagem]);
    useEffect(() => { setTipo(data.tipo || "texto"); }, [data.tipo]);
    useEffect(() => { setVariavel(data.variavel || ""); }, [data.variavel]);

    const handleMensagemChange = (v) => {
        setMensagem(v);
        onNodesChange([{ id, type: 'update', data: { mensagem: v } }]);
    };
    const handleTipoChange = (v) => {
        setTipo(v);
        onNodesChange([{ id, type: 'update', data: { tipo: v } }]);
    };
    const handleVariavelChange = (e) => {
        const v = e.target.value;
        setVariavel(v);
        onNodesChange([{ id, type: 'update', data: { variavel: v } }]);
    };

    useEffect(() => { conferePendencias(); }, [mensagem, tipo, variavel]);

    const conferePendencias = () => {
        const pendencias = [];
        if (!variavel) pendencias.push("Variável não selecionada");
        setListaPendencias(pendencias);
        return pendencias;
    };

    return (
        <div className="node node-mostrar">
            <div className="titulo-node">
                <FontAwesomeIcon icon="fa-solid fa-book" />
                {data.label.toUpperCase()}
            </div>
            <div className="linha-separadora" />
            <div className="node-geral">
                <div className="node-botoes">
                    <button title="Executar este comando" onClick={() => alert("Executar")}>
                        <FontAwesomeIcon icon="fa-solid fa-circle-play" />
                    </button>
                    <NodeHeaderCustomDeleteAction />
                    {listaPendencias.length > 0 && <NodeHeaderCustomAlertAction conferePendencias={conferePendencias} nodeData={data} />}
                </div>
                <div className="node-principal">
                    <span className="icon">Mensagem:</span>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', marginBottom: '8px' }}>
                        <button
                            onClick={() => setIsExpanded(!isExpanded)}
                            style={{
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                background: "#fafafa",
                                minWidth: "32px",
                                minHeight: "32px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            title={isExpanded ? "Minimizar editor" : "Expandir para textarea"}
                        >
                            {isExpanded ? <FontAwesomeIcon icon="fa-solid fa-minus" /> : <FontAwesomeIcon icon="fa-solid fa-plus" />}
                        </button>
                        <div style={{ flex: 1, maxWidth: '300px', minWidth: '250px', width: '100%' }}>
                            <InputRichVariavel
                                value={mensagem}
                                onChange={handleMensagemChange}
                                placeholder="Mensagem para o usuário ou arraste uma variável"
                                multiline={isExpanded}
                            />
                        </div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '8px' }}>
                        <label>
                            <input
                                type="radio"
                                value="texto"
                                checked={tipo === "texto"}
                                onChange={() => handleTipoChange('texto')}
                            />
                            Digitação livre
                        </label>
                        <label>
                            <input
                                type="radio"
                                value="logico"
                                checked={tipo === "logico"}
                                onChange={() => handleTipoChange('logico')}
                            />
                            Lógico (sim/não)
                        </label>
                    </div>
                    <div style={{ position: 'relative', width: '100%' }}>
                        <datalist id="variavel-list">
                            {variaveis.map((v, idx) => (
                                <option key={idx} value={v.nome} />
                            ))}
                        </datalist>
                        <CustomSelect
                            options={variaveis.map(v => v.nome)}
                            value={variavel}
                            onChange={handleVariavelChange}
                            placeholder="Arraste ou digite uma variável"
                            dragAndDrop={true}
                            inputProps={{ 'data-lernode-varinput': true }}
                            listId="variavel-list"
                        />

                    </div>
                    <CustomHandle type="target" position="top" connectionCount={1} allowLoopConnections={true} />
                    <CustomHandle type="source" position="bottom" connectionCount={1} />
                </div>
            </div>
        </div>
    );
};